import React from 'react';

const ProductList = ({ products, onEdit, onDelete }) => {
  if (!products || products.length === 0) {
    return (
      <div className="empty-state">
        <div className="empty-state-icon">📦</div>
        <h3>No products yet</h3>
        <p>Create your first product to get started</p>
      </div>
    );
  }

  return (
    <table className="data-table">
      <thead>
        <tr>
          <th>ფოტო</th>
          <th>სახელი</th>
          <th>კატეგორია</th>
          <th>ფასი</th>
          <th>მარაგი</th>
          <th>სტატუსი</th>
          <th>მოქმედება</th>
        </tr>
      </thead>
      <tbody>
        {products.map((product) => (
          <tr key={product.id}>
            <td>
              {product.primary_image ? (
                <img
                  src={`https://kid-o.ge${product.primary_image}`}
                  alt={product.name}
                  className="table-image"
                />
              ) : (
                <div className="table-image" style={{ 
                  backgroundColor: 'var(--light)', 
                  display: 'flex', 
                  alignItems: 'center', 
                  justifyContent: 'center',
                  fontSize: '1.5rem'
                }}>
                  📦
                </div>
              )}
            </td>
            <td style={{ fontWeight: 600 }}>{product.name}</td>
            <td>{product.category_name || 'Uncategorized'}</td>
            <td style={{ fontWeight: 600, color: 'var(--primary)' }}>
              ${parseFloat(product.price).toFixed(2)}
            </td>
            <td>
              <span className={`badge ${product.stock > 0 ? 'badge-success' : 'badge-error'}`}>
                {product.stock} მარაგში
              </span>
            </td>
            <td>
              <span className={`badge ${product.is_active ? 'badge-success' : 'badge-error'}`}>
                {product.is_active ? 'Active' : 'Inactive'}
              </span>
            </td>
            <td>
              <div className="action-buttons">
                <button
                  className="action-btn edit"
                  onClick={() => onEdit(product)}
                >
                  ✏️ შეცვლა
                </button>
                <button
                  className="action-btn delete"
                  onClick={() => onDelete(product.id)}
                >
                  🗑️ წაშლა
                </button>
              </div>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ProductList;